/**
 * Maps the 'schema' of the OAuth strategy to the 'settings' of the OAuth
 * provider. When creating a new OAuth provider, the 'settings' are empty and we
 * return only based on the schema and initialize with empty values.
 *
 * @param props.schema The schema of the OAuth strategy.
 * @param props.settings The optional settings of the OAuth provider.
 * @returns An object based on the schema of the OAuth strategy with mapped
 *   values if the settings are available.
 */
export const mapSchemaToSettings = ({ schema, settings, }) => schema.reduce((acc, schemaItem) => {
    var _a;
    const match = settings === null || settings === void 0 ? void 0 : settings.find((setting) => setting.key === schemaItem.key);
    return Object.assign(Object.assign({}, acc), { [schemaItem.key]: {
            value: (_a = match === null || match === void 0 ? void 0 : match.value) !== null && _a !== void 0 ? _a : '',
            secret: schemaItem.secret,
            // The property `isEditing` is used in order to show/hide the input field in
            // case it is a secret setting. However, when we create an OAuth provider we _always_
            // want to show the input field because it will be the first time that the user
            // enters a value for it.
            isEditing: !schemaItem.secret,
        } });
}, {});
